import {
  PayeeReviewStatus,
  PayerApprovalStatus
} from "@wingspanhq/wingspan-api-sdk";

type SelectorIsPayableRejectedParams = {
  payerApprovalStatus?: PayerApprovalStatus;
  payeeReviewStatus?: PayeeReviewStatus;
};

/**
 * Whether the payer's decline still stands. A contractor resubmission answers
 * the decline and hands the payable back to the payer, but leaves
 * `payerApprovalStatus` on `Declined` (PLA-2847), so the field alone overstates
 * the rejected population.
 *
 * `PayableRow` carries no resubmit timestamp, so this compares the two current
 * statuses where `selectorIsInvoiceRejected` compares the two events.
 */
export const selectorIsPayableRejected = ({
  payerApprovalStatus,
  payeeReviewStatus
}: SelectorIsPayableRejectedParams): boolean =>
  payerApprovalStatus === PayerApprovalStatus.DECLINED &&
  payeeReviewStatus !== PayeeReviewStatus.RESUBMITTED;
